import { useTranslation } from 'react-i18next';

const LANGS: Array<{ code: 'en' | 'fr' | 'ar'; label: string }> = [
  { code: 'en', label: 'EN' },
  { code: 'fr', label: 'FR' },
  { code: 'ar', label: 'AR' },
];

export function LanguageSelector() {
  const { i18n, t } = useTranslation();

  const changeLanguage = (lng: string) => {
    i18n.changeLanguage(lng);
    document.documentElement.dir = lng === 'ar' ? 'rtl' : 'ltr';
    document.documentElement.lang = lng;
  };

  return (
    <div className="flex items-center gap-2" role="group" aria-label="language">
      <select
        value={i18n.language}
        onChange={(e) => changeLanguage(e.target.value)}
        className="sr-only"
        aria-label="language"
      >
        {LANGS.map((l) => (
          <option key={l.code} value={l.code}>
            {t(`header.languages.${l.code}`)}
          </option>
        ))}
      </select>
      {LANGS.map((l, i) => (
        <span key={l.code} className="flex items-center gap-2">
          <button
            type="button"
            onClick={() => changeLanguage(l.code)}
            className={`editorial-label transition-colors ${
              i18n.language === l.code ? 'text-brass' : 'text-ash hover:text-ink'
            }`}
            aria-label={t(`header.languages.${l.code}`)}
          >
            {l.label}
          </button>
          {i < LANGS.length - 1 && <span className="text-linen text-xs">·</span>}
        </span>
      ))}
    </div>
  );
}
